module.exports = __webpack_public_path__ + "static/media/arwor-left.210b8e11.svg";